export var raTourLanguageFrench = {
    'ra-tour': {
        action: {
            last: 'Terminer',
            next: 'Suivant',
            skip: 'Passer',
            open: 'Ouvrir la boite de dialogue',
        },
    },
};
